// root '../../../';

// dependencies
import { Child } from "pym.js";
import Zion from "./utils/Zion";

import App from "./components/App.svelte";

const pkg = require("../package.json");

// polyfills
// import fetch from 'unfetch';
import "./utils/polyfills"; // (includes Array.findIndex && Array.find)

// utils & graphic
import { stylePremium } from "./utils/helpers";

// styles
import "./styles/index.scss";

/* develblock:start */
import meta from "./data/meta.json";

if (process.env.NODE_ENV === "development") {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ polling: 500 });

window.onload = () => {
  // necessary evil for right now

  // if (process.env.NODE_ENV === "development") {
  //   Object.keys(meta).forEach((id) => {
  //     const node = document.querySelector(`.${id}`);

  //     if (node) {
  //       node.innerHTML = meta[id];
  //     }
  //   });
  // }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split("?")[0]);
  }
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

const app = new App({
  target: document.getElementById("root"),
  props: {
    ...meta,
  },
});
